import callApi, { CallApiResult, getCustomerId } from 'src/api';
import {
    SCHEMA_COMM_BANK_ACCOUNT_DOCUMENT_SHAPE,
    SCHEMA_CONFIRM_GP_CONTRACT_DOCUMENT_SHAPE,
    SCHEMA_CONFIRM_REFERRAL_PARTNER_CONTRACT_DOCUMENT_SHAPE,
    SCHEMA_CUSTOMER_DOCUMENT_SHAPE,
    SCHEMA_DIRECT_DEBIT_DOCUMENT_SHAPE,
    SCHEMA_SET_SUCCESSOR_DOCUMENT_SHAPE,
} from 'src/schemas/CustomerDocument';

/* Customer Documents */

export const fetchCustomerDocuments = (): Promise<CallApiResult> => {
    const customerId = getCustomerId();
    const endpoint = '/api/customer/' + customerId + '/documents';
    return callApi(endpoint);
};

export const submitCustomerDocumentForm = (
    raw: SCHEMA_CUSTOMER_DOCUMENT_SHAPE,
    documentKey: string
): Promise<CallApiResult> => {
    const file = raw.file.item(0);

    if (file == null) return Promise.reject('no file');

    const data = new FormData();
    data.append('file', file);
    const customerId = getCustomerId();
    return callApi(`/api/customer/${customerId}/document/${documentKey}`, { method: 'POST', data });
};

export const fetchDirectDebitDocument = (): Promise<CallApiResult> => {
    const customerId = getCustomerId();
    return callApi('/api/customer/' + customerId + '/sepaData', { method: 'GET' });
};

export const submitDirectDebitDocument = (data: SCHEMA_DIRECT_DEBIT_DOCUMENT_SHAPE): Promise<CallApiResult> => {
    const customerId = getCustomerId();
    return callApi('/api/customer/' + customerId + '/setSepaData', { method: 'PUT', data });
};

export const fetchCommissionBankAccount = (): Promise<CallApiResult> => {
    const customerId = getCustomerId();
    return callApi('/api/customer/partner/' + customerId + '/commissionBankAccount', { method: 'GET' });
};

export const submitCommissionBankAccount = (data: SCHEMA_COMM_BANK_ACCOUNT_DOCUMENT_SHAPE): Promise<CallApiResult> => {
    const customerId = getCustomerId();
    return callApi('/api/customer/partner/' + customerId + '/commissionBankAccount', { method: 'PUT', data });
};

export const submitConfirmGpContract = (data: SCHEMA_CONFIRM_GP_CONTRACT_DOCUMENT_SHAPE): Promise<CallApiResult> => {
    const customerId = getCustomerId();
    return callApi('/api/customer/partner/' + customerId + '/confirmGpContract', { method: 'PUT', data });
};

export const submitConfirmReferralPartnerContract = (
    data: SCHEMA_CONFIRM_REFERRAL_PARTNER_CONTRACT_DOCUMENT_SHAPE
): Promise<CallApiResult> => {
    return callApi('/api/customer/partner/current/confirmReferralPartnerContract', { method: 'PUT', data });
};

export const submitSetSuccessor = (data: SCHEMA_SET_SUCCESSOR_DOCUMENT_SHAPE) => {
    const customerId = getCustomerId();
    return callApi('/api/successors/' + customerId + '/successor', { method: 'PUT', data });
};
